export { ReactComponent as IcoGameCard } from './IcoGameCard.svg';